import * as store from '@ngrx/store';

export enum TrainingActionTypes {
  AddPatient = '[patient]add',

  SetUser = '[user]',
  AddUser = '[user]add',
  DeleteUser = '[user]del',

  SetPlay = '[play]set',
  SetTaksIndex = '[task]index',
  SetSceneIndex = '[scene]index',
  AddTask = '[task]add',
  DelTask = '[task]del',

  DelTeacherVideo = '[teacher]del video',
  DelStep = '[step]del',

  SetScene = '[scene]set',
  AddScene = '[scene]add',

  SetCurrTime = '[movie]curr_time', //by the user
  SetPatientName = '[patient]name',

  Play = '[mv]play',
  Pause = '[mv]pause',
  StopRec = '[mv]stop',
  Rec = '[mv]rec',
  OtherRec = '[other]rec',

  DoneRecording = '[rec]done',
  SetSketches = '[scene]sketchs',
  SetSketch = '[sketch]set',
  SetSketchIndex = '[sketch]index',
  DelSketch = '[sketch]del',  //The other one sends this one
  SaveScene = '[scene]save',

  PlayScene = '[play]scene',

  UpdateProgress = '[progress]update',

  SetMIME = '[mime]',
  ClearTraining = '[training]clear',
  GotPatients = '[patients]got',
  SetSegment = '[seg]set',



  ZoomIn = '[tzi]',
  ZoomOut = '[tzo]',
  Zoom = '[zoom]val',

  SetZoomOrPan = '[zoom pan]set', //inserte it in the zoom queue
  RemoteZoomOrPan = '[rzoom_pan]set', //tell care to do it

}
export class AddPatient implements store.Action {
  readonly type = TrainingActionTypes.AddPatient;
  constructor(public patient_id: string, public first_name: string, public last_name: string) { }
}
export class SetUser implements store.Action {
  readonly type = TrainingActionTypes.SetUser;
  constructor(public user: any) { }
}
export class AddUser implements store.Action {
  readonly type = TrainingActionTypes.AddUser;
  constructor(public user: any) { }
}
export class DeleteUser implements store.Action {
  readonly type = TrainingActionTypes.DeleteUser;
  constructor(public user_id: string) { }
}
export class SetPlay implements store.Action {
  readonly type = TrainingActionTypes.SetPlay;
  constructor(public play: any) { }
}

export class SetTaksIndex implements store.Action {
  readonly type = TrainingActionTypes.SetTaksIndex;
  constructor(public index: number) { }
}
export class SetSceneIndex implements store.Action {
  readonly type = TrainingActionTypes.SetSceneIndex;
  constructor(public index: number) { }
}
export class AddTask implements store.Action {
  readonly type = TrainingActionTypes.AddTask;
  constructor(public name: string) { }
}
export class DelTask implements store.Action {
  readonly type = TrainingActionTypes.DelTask;
  constructor() { }
}
export class DelTeacherVideo implements store.Action {
  readonly type = TrainingActionTypes.DelTeacherVideo;
  constructor(public index: number, public act: string) { }
}
export class DelStep implements store.Action {
  readonly type = TrainingActionTypes.DelStep;
  constructor(public index: number) { }
}

export class SetScene implements store.Action {
  readonly type = TrainingActionTypes.SetScene;
  constructor(public name: string, public start: number, public end: number) { }
}
export class AddScene implements store.Action {
  readonly type = TrainingActionTypes.AddScene;
  constructor(public name: string, public start: number, public end: number) { }
}
export class SetCurrTime implements store.Action {
  readonly type = TrainingActionTypes.SetCurrTime;
  constructor(public curr_time: number) { }
}

export class SetPatientName implements store.Action {
  readonly type = TrainingActionTypes.SetPatientName;
  constructor(public first_name: string, public last_name: string) { }
}

export class Play implements store.Action { //steps, describe, problems
  readonly type = TrainingActionTypes.Play;
  constructor() { }
}

export class Pause implements store.Action { //steps, describe, problems
  readonly type = TrainingActionTypes.Pause;
  constructor() { }
}
export class StopRec implements store.Action { //steps, describe, problems
  readonly type = TrainingActionTypes.StopRec;
  constructor() { }
}
export class Rec implements store.Action { //steps, describe, problems
  readonly type = TrainingActionTypes.Rec;
  constructor() { }
}
export class OtherRec implements store.Action { //steps, describe, problems
  readonly type = TrainingActionTypes.OtherRec;
  constructor() { }
}
export class DoneRecording implements store.Action { //steps, describe, problems
  readonly type = TrainingActionTypes.DoneRecording;
  constructor(public duration: number, public bIsTask: boolean, public data: any) { }
}
export class SetSketches implements store.Action {
  readonly type = TrainingActionTypes.SetSketches;
  constructor(public sketches: any[], public scene_index: number) { }
}


export class SetSketch implements store.Action {
  readonly type = TrainingActionTypes.SetSketch;
  constructor(public sketch: any) { }
}
export class SetSketchIndex implements store.Action {
  readonly type = TrainingActionTypes.SetSketchIndex;
  constructor(public index: number) { }
}
export class DelSketch implements store.Action {
  readonly type = TrainingActionTypes.DelSketch;
  constructor(public index: number) { }
}
export class SaveScene implements store.Action {
  readonly type = TrainingActionTypes.SaveScene;
  constructor() { }
}
export class PlayScene implements store.Action {
  readonly type = TrainingActionTypes.PlayScene;
  constructor(public act: string, public index: number) { }
}

export class SetMIME implements store.Action {
  readonly type = TrainingActionTypes.SetMIME;
  constructor(public mime_ext: string, public mime_type: string) { }
}

export class ClearTraining implements store.Action {
  readonly type = TrainingActionTypes.ClearTraining;
  constructor() { }
}

export class GotPatients implements store.Action {
  readonly type = TrainingActionTypes.GotPatients;
  constructor(public patients: any) { }
}
export class SetSegment implements store.Action {
  readonly type = TrainingActionTypes.SetSegment;
  constructor(public start: number, public end: number) { }
}



export class ZoomIn implements store.Action {
  readonly type = TrainingActionTypes.ZoomIn;
  constructor(public width: number, public height: number) { }
}
export class ZoomOut implements store.Action {
  readonly type = TrainingActionTypes.ZoomOut;
  constructor(public width: number, public height: number) { }
}
export class Zoom implements store.Action {
  readonly type = TrainingActionTypes.Zoom;
  constructor(public zoom: number) { }
}
export class SetZoomOrPan implements store.Action {
  readonly type = TrainingActionTypes.SetZoomOrPan;
  constructor(public msg: any) { }
}
//remote calls
export class RemoteZoomOrPan implements store.Action {
  readonly type = TrainingActionTypes.RemoteZoomOrPan;
  constructor(public msg: any) { }
}

export class UpdateProgress implements store.Action {
  readonly type = TrainingActionTypes.UpdateProgress;
  constructor(public progress: any) { }
}












export type TrainingAction =
  AddPatient
  | SetUser
  | AddUser
  | DeleteUser

  | SetPlay
  | SetTaksIndex
  | SetSceneIndex
  | AddTask
  | DelTask


  | DelTeacherVideo
  | DelStep


  | SetScene
  | AddScene

  | SetCurrTime
  | SetPatientName

  | Play
  | Pause
  | StopRec
  | Rec
  | OtherRec


  | DoneRecording
  | SetSketches
  | SetSketch
  | SetSketchIndex
  | DelSketch
  | SaveScene

  | PlayScene

  | UpdateProgress
  | SetMIME
  | ClearTraining
  | GotPatients
  | SetSegment

  | ZoomIn
  | ZoomOut
  | Zoom

  | SetZoomOrPan
  | RemoteZoomOrPan

  ;
